import { TextField } from '@material-ui/core';
import { ConfirmOrCancel } from 'components/forms/ConfirmOrCancel';
import { BaseModal } from 'components/modals/BaseModal';
import { Card, CardHeader, CardHeaderContainer } from 'core/layout';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ConfirmationInputContainer = styled.div`
  padding: 1em;
  border-top: 1px solid #e0e0e0;
`;

const ConfirmationLabel = styled.p`
  margin: 0 0 0.5em 0;
  font-size: 14px;
`;

interface IProps {
  title: string;
  body: string;
  requireTextConfirmation?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export const DeleteConfirmationModal = (props: IProps) => {
  const { title, body, requireTextConfirmation = false, onCancel, onConfirm, isDeleting = false } = props;
  const [confirmationText, setConfirmationText] = useState<string>('');
  const isConfirmationValid = !requireTextConfirmation || confirmationText === 'DELETE';
  const { t } = useTranslation();

  return (
    <BaseModal title={title} onClose={onCancel}>
      <Card>
        <CardHeaderContainer>
          <CardHeader>{body}</CardHeader>
        </CardHeaderContainer>
        {requireTextConfirmation && (
          <ConfirmationInputContainer>
            <ConfirmationLabel>
              {t('Type')} <strong>DELETE</strong> {t('to confirm')}:
            </ConfirmationLabel>
            <TextField
              variant="outlined"
              fullWidth
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              placeholder="DELETE"
              size="small"
            />
          </ConfirmationInputContainer>
        )}
      </Card>
      
      <ConfirmOrCancel
        confirmText={t('Delete')}
        handleConfirmClick={onConfirm}
        confirmIsDisabled={!isConfirmationValid}
        handleCancelClick={onCancel}
        confirmIsPending={isDeleting}
        destructive={true}
      />
    </BaseModal>
  );
};

